// extracted by mini-css-extract-plugin
module.exports = {"Submit":"OrganisationForm_Submit__3jCdT","SubmitError":"OrganisationForm_SubmitError__C9llC"};